<template>

    <div class="modal attendance-modal fade" id="archivedConversationsModal" tabindex="-1" aria-labelledby="archivedConversationsModal" aria-hidden="true" style="z-index:9999;">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header rounded-bottom-0 py-3 px-4 bg-primary">
                    <div>
                        <p class="text-lg mb-0 fw-semibold">Gearchiveerde gesprekken</p>
                    </div>
                    <button v-on:click="hideModal()" type="button" class="btn-close mb-0 me-0" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>

                <div class="modal-body pt-3 pb-4 px-4">

                    <!-- Eén zoekveld (volledige breedte) voor dossiernummer, postcode, huisnummer en berichtinhoud -->
                    <div class="mb-4 w-full position-relative">
                        <input
                            type="text"
                            class="w-full form-control conversations-search-input"
                            v-model="searchQuery"
                            placeholder="Zoek op dossier, postcode, huisnummer of berichtinhoud"
                            v-on:keyup.enter="searchArchivedConversations()"
                        >
                        <span
                            v-if="searchQuery"
                            v-on:click="clearSearch()"
                            class="position-absolute clear-search-btn"
                            role="button"
                            title="Wissen"
                        >
                            <i class="fa fa-times"></i>
                        </span>
                        <span
                            v-on:click="searchArchivedConversations()"
                            class="position-absolute search-icon-btn"
                            role="button"
                            title="Zoeken"
                        >
                            <i class="fa fa-search" :class="{ 'fa fa-circle-o-notch fa-spin' : searchLoader }"></i>
                        </span>
                    </div>

                    <div v-if="showResults" class="mb-3">
                        <label class="form-label fw-semibold">Zoekresultaten</label>
                        <div v-if="searchResults.length > 0">
                            <div class="list-group">
                                <a
                                    v-for="result in searchResults"
                                    :key="result.id"
                                    href="#"
                                    class="list-group-item list-group-item-action"
                                    @click.prevent="showConversation(result)"
                                >
                                    <div class="w-full flex gap-2">
                                        <div v-if="result.dossier_nr" v-html="highlight(result.dossier_nr)"></div>
                                        <div v-html="highlight(result.order_name)"></div>
                                        <div class="ms-auto">
                                            <small class="d-block text-muted">{{ result.status }}</small>
                                        </div>
                                    </div>
                                    <div v-if="result.match_snippet" class="mt-1 text-sm text-lightgrey search-result-snippet">
                                        <i
                                            class="me-1"
                                            :class="result.match_type === 'message' ? 'fa fa-comment-o' : 'fa fa-map-marker'"
                                        ></i>
                                        <span v-html="highlight(result.match_snippet)"></span>
                                    </div>
                                    <div v-if="result.users_count" class="mt-1 text-sm text-lightgrey search-result-users">
                                        <i class="fa fa-users me-1"></i>
                                        <span>{{ result.users_count }} {{ result.users_count === 1 ? 'deelnemer' : 'deelnemers' }}</span>
                                        <span v-if="result.users && result.users.length"> &middot; {{ result.users.join(', ') }}</span>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div v-else class="mb-3">Geen resultaten gevonden</div>
                    </div>

                    <div v-if="archivedConversations.length === 0" class="text-center py-4">
                        <p>Geen gearchiveerde gesprekken gevonden.</p>
                    </div>

                    <div v-else class="messages">
                        <div
                            v-for="conversation in archivedConversations" :key="conversation.id"
                            class="message"
                        >
                            <div class="content hasBeenRead" v-on:click="showConversation(conversation)" role="button">
                                <div class="d-flex flex-column-reverse flex-sm-row align-items-baseline">
                                    <p class="sender">
                                        <span v-if="conversation.is_internal">{{ conversation.conversation_users }}</span>
                                        <span v-if="!conversation.is_internal">{{ conversation.last_message.user }}</span>
                                        <i class="fa fa-paper-plane ms-1"></i>
                                    </p>
                                    <span class="date ms-sm-auto">
                                        {{ conversation.last_message.created_at }}
                                    </span>
                                </div>
                                <div>
                                    <p class="mb-0 fw-semibold">
                                        <i v-if="conversation.is_internal" class="fa fa-users text-primary me-2" title="Intern gesprek"></i>
                                        <span v-if="conversation.is_internal">{{ conversation.conversation_users }} - </span>
                                        <span v-if="!conversation.is_internal && conversation.dossier_nr">#{{ conversation.dossier_nr }} - </span>
                                        {{ conversation.order_name }}
                                    </p>
                                    <p v-html="conversation.last_message.message_limit" class="text-sm text-lightgrey mb-0"></p>
                                </div>
                            </div>
                            <div class="actions">
                                <span v-if="conversation.can_restore" v-on:click="resetConversationItemByUser(conversation)" role="button">
                                    <i class="fa fa-recycle"></i>
                                </span>
<!--                                <span v-on:click="deleteConversation(conversation)" role="button">-->
<!--                                    <i class="fa fa-trash-o"></i>-->
<!--                                </span>-->
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>

</template>

<script>
import {EventBus} from "../../../event-bus";

export default {
    name: 'archived-conversations-modal',
    data() {
        return {
            archivedConversations: [],
            loading: true,

            searchQuery: '',
            searchResults: [],
            showResults: false,
            searchLoader: false,
        }
    },
    methods: {
        getArchivedConversations() {
            this.loading = true;
            axios.get('api/get-archived-conversations')
                .then(response => {
                    if (response.data.status === 422) {
                        throw [true, response.data.message];
                    }

                    this.archivedConversations = response.data.conversationItems || [];
                    this.loading = false;
                })
                .catch(e => {
                    this.$swal("Er is een fout opgetreden", e[0] === true ? e[1] : "Er is iets mis gegaan bij het ophalen van de gearchiveerde gesprekken.", "error");
                    this.loading = false;
                });
        },
        searchArchivedConversations() {
            if (this.searchQuery.trim() === '') {
                this.searchResults = [];
                this.showResults = false;
                return;
            }

            this.searchLoader = true;

            axios.get('api/search-archived-conversations', {
                params: {
                    query: this.searchQuery
                }
            })
            .then(response => {
                if (response.data.status === 422) {
                    throw [true, response.data.message];
                }
                this.searchResults = response.data.results || [];
                this.searchLoader = false;
                this.showResults = true;
            })
            .catch(e => {
                this.searchLoader = false;
                this.$swal("Er is een fout opgetreden", e[0] === true ? e[1] : "Er is iets mis gegaan bij het zoeken.", "error");
            });
        },
        escapeHtml(value) {
            return String(value)
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/"/g, '&quot;')
                .replace(/'/g, '&#039;');
        },
        escapeRegExp(value) {
            return String(value).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        },
        highlight(text) {
            const safe = this.escapeHtml(text ?? '');
            const term = (this.searchQuery || '').trim();

            if (term === '') {
                return safe;
            }

            const pattern = new RegExp('(' + this.escapeRegExp(this.escapeHtml(term)) + ')', 'gi');
            return safe.replace(pattern, '<mark>$1</mark>');
        },
        clearSearch() {
            this.searchQuery = '';
            this.searchResults = [];
            this.showResults = false;
        },
        showConversation(conversation) {
            axios.get('api/get-conversation-messages/' + conversation.id)
                .then(response => {
                    if (response.data.status === 422) {
                        throw [true, response.data.message];
                    }

                    this.modal.hide();
                    EventBus.$emit('conversationSelected', response.data);
                })
                .catch(e => {
                    this.$swal("Er is een fout opgetreden", e[0] === true ? e[1] : "Er is iets mis gegaan bij het ophalen van de data", "error");
                });
        },
        resetConversationItemByUser(conversation) {
            let parent = this;

            this.$swal({
                title: "Gesprek terugzetten. Weet je het zeker?",
                text: "",
                showCancelButton: true,
                cancelButtonColor: "#3EBE00",
                confirmButtonColor: "#DD3444",
                confirmButtonText: "Ja, terugzetten",
                cancelButtonText: "Annuleren",
            }).then(
                function (callBack) {
                    if (callBack.isConfirmed) {
                        axios.post('api/reset-conversation-item-by-user', {
                            conversationId: conversation.id,
                        })
                        .then(response => {
                            if (response.data.status === 422) {
                                throw [true, response.data.message];
                            }
                            parent.getArchivedConversations();
                            parent.refetchParentMessages();
                        })
                        .catch(e => {
                            parent.$swal("Er is een fout opgetreden", e[0] === true ? e[1] : "Er is iets mis gegaan bij het verwijderen van het gesprek.", "error");
                        });
                    }
                }
            );
        },
        deleteConversation(conversation) {
            let parent = this;

            this.$swal({
                title: "Gesprek verwijderen. Weet je het zeker?",
                text: "Deze actie kan niet ongedaan gemaakt worden.",
                showCancelButton: true,
                cancelButtonColor: "#3EBE00",
                confirmButtonColor: "#DD3444",
                confirmButtonText: "Ja, verwijderen",
                cancelButtonText: "Annuleren",
            }).then(
                function (callBack) {
                    if (callBack.isConfirmed) {
                        axios.post('api/delete-conversation', {
                            conversationId: conversation.id,
                        })
                        .then(response => {
                            if (response.data.status === 422) {
                                throw [true, response.data.message];
                            }
                            parent.getArchivedConversations();
                            parent.refetchParentMessages();
                        })
                        .catch(e => {
                            parent.$swal("Er is een fout opgetreden", e[0] === true ? e[1] : "Er is iets mis gegaan bij het verwijderen van het gesprek.", "error");
                        });
                    }
                }
            );
        },
        refetchParentMessages() {
            EventBus.$emit('refetchConversations');
        },
        hideModal() {
            EventBus.$emit('refetchConversations');
            this.modal.hide();
        },
    },
    mounted() {
        this.modal = new bootstrap.Modal(document.getElementById('archivedConversationsModal'));

        EventBus.$on('openArchivedConversationsModal', () => {
            this.clearSearch();
            this.getArchivedConversations();
            this.modal.show();
        });
    }
}
</script>

<style>

.swal2-container {
    z-index: 9999;
}

.conversations-search-input {
    padding-right: 64px;
}

.clear-search-btn {
    top: 50%;
    right: 40px;
    transform: translateY(-50%);
    color: #aaa;
    line-height: 1;
}

.clear-search-btn:hover {
    color: #666;
}

.search-icon-btn {
    top: 50%;
    right: 14px;
    transform: translateY(-50%);
    color: #888;
    line-height: 1;
}

.search-icon-btn:hover {
    color: #444;
}

.search-result-users {
    line-height: 1.4;
}

.search-result-snippet {
    word-break: break-word;
    line-height: 1.4;
}

.search-result-snippet mark,
.list-group-item mark {
    background-color: #fff3b0;
    padding: 0 1px;
    border-radius: 2px;
}
</style>
